<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-28 16:45:39
-->
<template>
  <div>
    <el-drawer
      title="申请详情"
      :visible.sync="visible"
      @closed="closeTwo"
      :destroy-on-close="true"
      size="900px"
      :with-header="true"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <div class="top">
          <div class="log-box">
            <div
              @click="changeType(1)"
               v-if="codeData.indexOf('306') != -1"
              :style="[
                { color: type == 1 ? '#1890FF' : 'rgba(102, 111, 128, 1)' },
                { background: type == 1 ? '#fff' : '#F5F7FA' },
              ]"
              class="log"
            >
              申请信息
            </div>
            <div
              v-if="codeData.indexOf('307') != -1"
              @click="changeType(2)"
              :style="[
                { color: type == 2 ? '#1890FF' : 'rgba(102, 111, 128, 1)' },
                { background: type == 2 ? '#fff' : '#F5F7FA' },
              ]"
              class="log"
            >
              日志记录
            </div>
          </div>
        </div>
        <ApplicationInformation :isShow="visible"  :itemData="itemData" v-if="type == 1 && codeData.indexOf('306') != -1" />
        <logging :isShow="visible" :itemData="itemData" v-if="type == 2 && codeData.indexOf('307') != -1" />
        <el-form-item class="bottom">
          <div class="form-bottom">
            <el-button  v-if="codeData.indexOf('309') != -1" @click="banLi" type="primary">办理</el-button>
            <el-button
              :loading="loading"
              plain
              @click="zhuanJiao"
              v-if="codeData.indexOf('308') != -1"
              type="primary"
              style="margin-left: 14px"
              >转交</el-button
            >
            <el-button  v-if="codeData.indexOf('305') != -1"  @click="open" style="margin-left: 14px" type="danger">删除</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog
      title="办理申请"
      :visible.sync="dialogVisibleColum"
      width="535px"
      class="column-box"
      :before-close="handleCloseColum"
      top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px" class="el-icon-info"></i
        >该处理信息将同步显示给申请人查看
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
         ref="ruleFormBase"
        label-width="110px"
        class="demo-ruleForm-two"
      >
        <el-form-item label="办理状态" prop="status">
          <el-select v-model="ruleForm.status" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="办理单位" prop="handlingUnit">
          <!-- <el-input
            v-model="ruleForm.handlingUnit"
            placeholder="请输入办理单位"
          ></el-input> -->
           <a-tree-select
                    v-model="ruleForm.organizationId"
                    style="width: 100%"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :tree-data="treeData"
                    @change="changOne"
                    placeholder="请选择受理机关"
                  >
                  </a-tree-select>
                 
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="ruleForm.remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleColum = false">取 消</el-button>
        <el-button :loading="loadingBtn" type="primary" @click="submit"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="转交申请"
      :visible.sync="dialogVisibleColumTwo"
      width="535px"
      class="column-box"
      :before-close="handleCloseColumTwo"
      top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px" class="el-icon-info"></i
        >该申请信息将转交至目标单位进行办理
      </div>
      <el-form
        :model="ruleFormTwo"
        ref="ruleFormTwo"
        label-width="100px"
        class="demo-ruleForm-three"
      >
        <el-form-item label-width="0px">
            <div style="display:flex">
              <div style="width:100px;margin-left:18px;"><span style="color:red">*</span> 转交目标</div>
               <el-input
                placeholder="请选择所属组织"
                class="selectTree-input"
                auto-complete="off"
                v-model="form.input1"
                @click.native="!isDisable?changeSelectTree():''"
                @blur="hideParentClick"
                :disabled="isDisable"
              >
            </el-input>
            </div>
            <i v-if="!isShowSelect"  class="el-icon-arrow-down icon"></i>
            <i v-if="isShowSelect"  class="el-icon-arrow-up icon"></i>
            <el-tree
              id="floatTree"
              v-if="!isDisable"
              v-show="isShowSelect"
              empty-text="暂无数据"
              :highlight-current="true"
              :default-expand-all="false"
              :expand-on-click-node="true"
              :data="data"
              node-key="value"
              :default-expanded-keys="defaultSelect"
              :filter-node-method="filterNode"
              @node-click="selectClassfy"
              class="selectTree-input objectTree"
              ref="selectTree"
            >
            </el-tree>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="ruleFormTwo.remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleColumTwo = false">取 消</el-button>
        <el-button
          :loading="loadingBtnTwo"
          type="primary"
          @click="submitTwo"
          >确定</el-button
        >
      </span>
    </el-dialog>
     <el-dialog
            title="确认删除此申请吗?"
            :visible.sync="dialogVisibleTwo"
            width="450px"
            custom-class="tips-box"
            :before-close="handleClose"
            top="17%"
            >
            <span
                >确认删除此申请吗</span
            >
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleTwo = false">取消</el-button>
                <el-button :loading="deleteShow" type="danger" @click="deleteOne()"
                >确认删除</el-button
                >
            </span>
        </el-dialog>
  </div>
</template>

<script>
import ApplicationInformation from "./application_Information.vue";
import logging from "./logging.vue";
import { organTree,handle,careOf,deleteRow,selectListData } from "../index";
import { message } from 'ant-design-vue';
export default {
  data() {
    return {
      grouplist: [],
      loading: false,
      type: 1,
      codeData: [],
      isDisable: false,
      isDisableTwo: false,
      dialogVisibleColum: false,
      dialogVisibleColumTwo: false,
      deleteShow:false,
      textarea: "",
      textareaTwo: "",
      ruleForm: {},
      ruleFormTwo: {},
      loadingBtn: false,
      collectTimeValue: "",
      isShowSelect: false,
      isShowSelectTwo: false,
      defaultSelect: [],
      defaultSelectTwo: [],
      dialogVisibleTwo:false,
      loadingBtnTwo:false,
      data: [],
      form: {
        input1: "",
      },
      options: [
        {
          value: "0",
          label: "待受理",
        },
        {
          value: "1",
          label: "办理中",
        },
        {
          value: "2",
          label: "已办结",
        },
      ],
      rules: {
        status: [
          { required: true, message: "请选择办理状态", trigger: "blur" },
        ],
        handlingUnit: [
          { required: true, message: "请选择办理状态", trigger: "blur" },
        ],
      },
      treeData:[],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    itemData: {
      type: Object,
      default: {},
    },
  },
  components: {
    ApplicationInformation,
    logging,
  },
  mounted() {
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    this.getTree();
     if(this.codeData.indexOf('306') == -1){
          this.type = 2;
          return;
      }
  },
  methods: {
     open(){
            this.dialogVisibleTwo = true;
        },
        changOne(value,label){
        this.ruleForm.handlingUnit = label[0];
    },
    getShouLiJiGuan() {
      selectListData({}).then((res) => {
        if (res.code == 0) {
           let options = JSON.stringify(res.data)
                        .replace(/organizationName/g, "title")
                        .replace(/id/g, "value")
              this.treeData = JSON.parse(options)
        }
      });
    },
    getTree() {
      organTree({}).then((res) => {
        if (res.code == 0) {
          let options = JSON.stringify(res.data).replace(
            /organizationName/g,
            "label"
          );
          this.data = JSON.parse(options);
        }
      });
    },
    deleteOne(){
        this.deleteShow = true;
        deleteRow({
          id:this.itemData.id,
        }).then((res)=>{
            if(res.code == 0){
                 this.dialogVisibleTwo = false;
                 this.deleteShow = false;
                this.$emit("close");
            }
        })
    },
    closeTwo(){
        this.$emit('closeTwo')
    },
    submit() {
      this.loadingBtn = true;
      this.ruleForm.isApplyOpenId = this.itemData.id;
       this.$refs.ruleFormBase.validate((valid) => {
          if(valid){
            handle({
              ...this.ruleForm,
               siteId:sessionStorage.getItem('siteId')
            }).then((res)=>{
              if(res.code == 0){
                this.dialogVisibleColum = false;
                 this.loadingBtn = false;
                this.$emit("close");
              }else{
                this.loadingBtn = false;
              }
            })
          }else{
            this.loadingBtn = false;
          } 
      })
    },
    submitTwo(){
      this.loadingBtnTwo = true;
      this.ruleFormTwo.isApplyOpenId = this.itemData.id;
      if(!this.ruleFormTwo.organizationId){
        message.error('请选择转交目标')
        this.loadingBtnTwo = false;
        return;
      }
      this.ruleFormTwo.transferTarget = this.form.input1;
      this.ruleFormTwo.siteId = sessionStorage.getItem('siteId');
       careOf(this.ruleFormTwo).then((res)=>{
              if(res.code == 0){
                this.dialogVisibleColumTwo = false;
                this.$emit("close");
              }else{
                
              }
               this.loadingBtnTwo = false;
            })

    },
    close() {
      this.$emit("close");
    },
    changeType(type) {
      this.type = type;
    },
    banLi() {
      this.dialogVisibleColum = true;
      this.getShouLiJiGuan()
      this.ruleForm = {};
    },
    zhuanJiao() {
      this.dialogVisibleColumTwo = true;
      this.ruleFormTwo = {};
      this.form.input1 = '';
    },
    handleCloseColum() {
      this.dialogVisibleColum = false;
    },
    handleClose(){
        this.dialogVisibleTwo = false;
    },
    handleCloseColumTwo() {
      this.dialogVisibleColumTwo = false;
    },
    selectClassfy(data) {
      this.form.input1 = data.label;
      this.ruleFormTwo.organizationId = data.id;
      this.isShowSelect = false;
    },
    changeSelectTree() {
      this.isShowSelect = true;
    },
    hideParentClick(e) {
      var isOther =
        e.relatedTarget == null ||
        e.relatedTarget.closest("div.el-tree") == null ||
        e.relatedTarget.closest("div.el-tree").id != "floatTree";

      if (isOther) {
        this.isShowSelect = false;
      } else {
        e.target.focus();
      }
    },
    // 选择器的树节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    }
  },
  created() {},
  watch: {
    form: {
      handler(form) {
        if (this.isShowSelect) {
          this.$refs.selectTree.filter(form.input1);
        }
      },
      deep: true, //深度监听，重要
    },
    visible(val){

    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 10px;
  padding-top: 10px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 14px;
}
.el-drawer__close-btn{
  font-size: 14px;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.demo-ruleForm {
  padding-right: 24px;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item__label {
  text-align: left;
  padding-left: 22px;
}
.remard {
  text-indent: 10px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .ant-select-selection__placeholder {
  color: #415058;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  border-top: solid 1px #e5e7ec;
  width: 100%;
  background: #fff;
  .form-bottom {
    margin-right: 24px;
    padding: 15px 0px;
  }
}
/deep/ .el-select .el-input .el-select__caret {
  color: #000;
}
.top {
  padding: 24px;
  padding-bottom: 10px;
  padding-right: 0px;
  padding-top: 0px;
}
.log-box {
  border-bottom: solid 1px #dcdfe6;
  display: flex;
  color: #000;
  .log {
    padding: 10px 20px;
    border-top: solid 1px #dcdfe6;
    border-left: solid 1px #dcdfe6;
    cursor: pointer;
  }
  .log:last-child {
    border-right: solid 1px #dcdfe6;
  }
}
.head {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #dcdfe6;
  padding: 18px 24px;
}
.back {
  cursor: pointer;
}
/deep/ .el-form-item {
  margin-bottom: 0px;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 20px;
}
.demo-ruleForm-two {
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }
}
/*下拉框选择树*/
.objectTree {
  position: absolute;
  overflow: auto;
  z-index: 100;
  height: 200px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 204;
  margin-left: 100px;
  width: 397px;
}
/deep/ .el-tree-node__expand-icon {
  font-size: 14px;
  font-weight: 600;
}
.icon {
  position: absolute;
  right: 9px;
  top: 15px;
}
.demo-ruleForm-three{
    height: 300px;
    /deep/ .el-form-item {
    margin-bottom: 30px;
  }
}
/deep/ .ant-select-selection__rendered{
  line-height: 40px;
}
/deep/ .ant-select-selection--single{
  height: 40px;
}
</style>